import { createSlice } from '@reduxjs/toolkit';

import { initialPaymentState } from './initialState';
import { createPaymentAddress } from 'src/thunk/payment';
import { EPricingMode, EInvoice } from 'src/store/slice/payment/interface';
import { ERequestStatus } from 'src/api/enumRequest';

const paymentSlice = createSlice({
  name: 'payment',
  initialState: initialPaymentState,
  reducers: {
    setPaymentSuccess: (state, action) => {
      state.getPayment.status = ERequestStatus.success;
      state.getPayment.payment = action.payload.payment;
    },

    setPaymentFailed: (state) => {
      state.getPayment.status = ERequestStatus.failed;
    },

    setWidgetLanguages: (state, action) => {
      state.widgetLanguages = action.payload.widget_languages;
    },

    setWidgetSettings: (state, action) => {
      if (action.payload.widget_setting) {
        try {
          state.widgetSettings = JSON.parse(action.payload.widget_setting);
        } catch (e) {
          state.widgetSettings = action.payload.widget_setting;
        }
      }
    },

    setPaymentTransactionsData: (state, action) => {
      state.getPaymentTransactions = action.payload.transactions;
    },

    setPaymentTransactionData: (state, action) => {
      const isСurrentTransaction = state.getPaymentTransactions.find((transaction: any) => {
        return transaction.crypto_transaction_id === action.payload.crypto_transaction_id;
      });

      if (isСurrentTransaction) {
        state.getPaymentTransactions = state.getPaymentTransactions.map((transaction: any) => {
          if (transaction.crypto_transaction_id === action.payload.crypto_transaction_id) {
            return {
              ...transaction,
              confirmations: action.payload.confirmations,
              status: action.payload.status,
            };
          }

          return transaction;
        });
      } else {
        state.getPaymentTransactions = [...state.getPaymentTransactions, action.payload];
      }
    },

    setPaymentDataAfterPaid: (state, action) => {
      if (state.getPayment.payment) {
        state.getPayment.payment.client_status = action.payload.client_status;
        state.getPayment.payment.expiration = action.payload.expiration;
        state.getPayment.payment.target_currency_amount_left = action.payload.target_currency_amount_left;
      }
    },

    setPaymentTestData: (state) => {
      state.getPayment.status = ERequestStatus.success;
      state.getPayment.payment = {
        client_status: 'Pending',
        created: '2023-08-01T09:32:48.895551Z',
        updated: '2023-08-01T09:32:48.895551Z',
        currency_id: 'ETH',
        currency_network: 'GOERLI',
        currency_settings: [
          {
            enabled: true,
            currency_id: 'ETH',
            network: 'GOERLI',
            is_converted: true,
            required_confirmations: 2,
            is_preferred: false,
            type: 'Crypto',
          },
          {
            enabled: true,
            currency_id: 'BTC',
            network: 'BITCOIN',
            is_converted: false,
            required_confirmations: 3,
            is_preferred: true,
            type: 'Crypto',
          },
        ],
        currency_type: 'Crypto',
        expiration: 3587,
        id: '8497ebd0-8868-4439-8334-027d161a9c2f',
        target_currency_amount_left: 0,
        target_currency_amount_paid: 0,
        target_currency_amount_required: 1.0175,
        type: EInvoice.Invoice,
        pricing_mode: EPricingMode.LongLivedQuote,
        is_fees_in_price_quote: false,
        merchant_order_description: 'Test',
        fees_values: [],
        passthrough_fees: false,
        total_fee_amount: 0,
        parent_merchant_fee_amount: 0,
        merchant_fee_amount: 0,
      };
    },

    setWidgetLanguageTestData: (state) => {
      state.widgetLanguages = [{ id: 'en', name: 'English' }];
    },

    setCreatedPaymentAddressTestData: (state) => {
      state.createPaymentAddress.address = '2165621d-35ee-4350-b167-5c01d9c08ccf';
      state.createPaymentAddress.address = '0x78d9adF8B86C31BB31cF2F83C0b84cf72034448e';
      state.createPaymentAddress.address_currency_id = 'ETH';
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createPaymentAddress.pending, (state) => {
        state.createPaymentAddress.status = ERequestStatus.pending;
        state.createPaymentAddress.error = '';
      })
      .addCase(createPaymentAddress.fulfilled, (state, action) => {
        state.createPaymentAddress.status = ERequestStatus.success;
        state.createPaymentAddress.address = action.payload.address;
        state.createPaymentAddress.address_currency_id = action.payload.address_currency_id;
        state.createPaymentAddress.address_id = action.payload.address_id;
        state.createPaymentAddress.tag_type = action.payload.tag_type;
        state.createPaymentAddress.tag_value = action.payload.tag_value;
      })
      .addCase(createPaymentAddress.rejected, (state, action: any) => {
        state.createPaymentAddress.status = ERequestStatus.failed;
        state.createPaymentAddress.error = action.payload;
      });
  },
});

export const {
  setPaymentTestData,
  setWidgetLanguageTestData,
  setCreatedPaymentAddressTestData,
  setPaymentSuccess,
  setPaymentFailed,
  setWidgetLanguages,
  setWidgetSettings,
  setPaymentDataAfterPaid,
  setPaymentTransactionData,
  setPaymentTransactionsData,
} = paymentSlice.actions;
export default paymentSlice.reducer;
